import { render, staticRenderFns } from "./EditBankModal.vue?vue&type=template&id=71f4ac16&scoped=true&"
import script from "./EditBankModal.vue?vue&type=script&lang=js&"
export * from "./EditBankModal.vue?vue&type=script&lang=js&"
import style0 from "./EditBankModal.vue?vue&type=style&index=0&id=71f4ac16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f4ac16",
  null
  
)

export default component.exports